"use client";

import { MY_AGENT_MENU } from "@/constants/menu";
import { IMenuBase } from "@/interfaces/IMenu";
import clsx from "clsx";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface IMenuProfile {
  list: Pick<
    IMenuBase,
    "id" | "label" | "href" | "icon" | "iconActive" | "chip"
  >[];
  className?: string;
  classNameUl?: string;
  classNameActive?: string;
  classNameNoActive?: string;
}

export default function MenuProfile({
  list = MY_AGENT_MENU,
  className,
  classNameUl,
  classNameActive,
  classNameNoActive,
}: IMenuProfile) {
  const pathName = usePathname();

  return (
    <div
      id="my-agent-menu"
      className={clsx(
        "flex flex-col p-4 self-stretch border-y border-base-divider",
        className,
      )}
    >
      <ul className={clsx("flex flex-col", classNameUl)}>
        {list.map((menu) =>
          pathName === menu.href ? (
            <Link key={menu.id} href={`${menu.href}`}>
              <div
                className={clsx(
                  "w-full h-[48px] lg:py-3.5 px-1 lg:px-4 flex items-center gap-2 bg-[#0A0F290A] rounded-full",
                  classNameActive,
                )}
              >
                {menu.iconActive}
                <p>{menu.label}</p>
                {menu.chip}
              </div>
            </Link>
          ) : (
            <Link key={menu.id} href={`${menu.href}`}>
              <div
                key={menu.id}
                className={clsx(
                  "w-full h-[48px] py-3.5 px-2 flex items-center gap-2 hover:bg-[#0a0f2914] hover:border hover:border-solid hover:rounded-full",
                  classNameNoActive,
                )}
              >
                {menu.icon}
                <p>{menu.label}</p>
              </div>
            </Link>
          ),
        )}
      </ul>
    </div>
  );
}
